import { curSym } from "../../utils/pip";
import { useEffect, useRef } from "react";
import Loader from "../../components/loader";
import MenuLayout from "../../layouts/MenuLayout";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { coachPaths } from "../../routes/coach";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import EBookSlider from "../../components/slider/EBookSlider";
import WorkshopSlider from "../../components/slider/WorkshopSlider";
import { useDispatch, useSelector } from "react-redux";
import { getAllCoachWorkshopByCoachId, getCoachEBookByID } from "../../redux/features/coach/actions/authAction";

export const CoachProfile = () => {
  const { id } = useParams();
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const user = { name: "find-a-coach", role: "coach" };
  const { isLoading, getAllCoachWorkshop, coachEbook } = useSelector((state) => state.coach.auth);

  useEffect(() => {
    window.scroll(0, 0);
    dispatch(getAllCoachWorkshopByCoachId({ payload: id }));
    dispatch(getCoachEBookByID({ payload: `${id}?content_type=eBook` }));
  }, []);

  if (isLoading) {
    return <Loader />;
  };

  return (
    <MenuLayout user={user}>
      <section
        class="ct_px_40    py-5"
        style={{
          background:
            "linear-gradient(to right, rgba(142, 202, 230, 0.26), rgb(2 48 71 / 24%))",
        }}
      >
        <div class="container-fluid">
          <div class="row align-items-center">
            <div
              class="col-xxl-7 col-xl-7 col-md-8 mb-4 mb-md-0 aos-init aos-animate"
              data-aos="fade-right"
              data-aos-duration="1500"
            >
              <div class="ct_px_40 ct_px_0_767">
                <h2 class="ct_fs_50 mb-4 ct_darkblue_text ">
                  Meet{" "}
                  <span className="ct_yellow_text">
                    {state?.data?.full_name ?? ""}
                  </span>
                </h2>
                <p
                  class="mb-0 mt-3 ct_fs_20 ct_darkblue_text"
                  style={{ maxWidth: "550px" }}
                >
                  {state?.data?.bio ?? ""}
                </p>
                <div class="ct_mt_40">
                  <a
                    class="ct_yellow_btn   px-4 ct_fit_content ct_h_48 gap-3"
                    data-bs-target="#ct_schedule_interview"
                    data-bs-toggle="modal"
                  >
                    <svg
                      width="18"
                      height="20"
                      viewBox="0 0 18 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9 3H16C16.55 3 17 3.45 17 4V18C17 18.55 16.55 19 16 19H2C1.45 19 1 18.55 1 18V4C1 3.45 1.45 3 2 3H9Z"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M4 3V1M14 3V1"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M4 10H14"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M4 14H11"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    Schedule Interview
                  </a>
                </div>
              </div>
            </div>
            <div
              class="col-xxl-5 col-xl-5 col-md-4 mb-4 mb-md-0 aos-init aos-animate"
              data-aos="fade-left"
              data-aos-duration="1500"
            >
              <div class="ct_boocamp_img_left">
                <img
                  src={
                    state?.data?.profile_image ??
                    "../assets/img/coach-profile_right_img.png"
                  }
                  alt=""
                  class="ct_img_h_458 w-100"
                  style={{ objectFit: "contain" }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="ct_we_looking_bg ct_pt_63_pb_30">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12 mb-4 mb-md-0">
              <div className="ct_coaching_grids_3">
                <h4 className="ct_fs_32 mb-0 ct_darksky_blue_text">
                  {state?.data?.full_name ?? ""}{" "}
                </h4>
                <span className="ct_verticle_line_decoration"></span>
                <div>
                  <h4 className="ct_fs_24  mb-3 ct_darksky_blue_text">
                    Based on 130+ verified sessions
                  </h4>
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <i class="fa-solid fa-star ct_yellow_text ct_fs_24"></i>
                    <i class="fa-solid fa-star ct_yellow_text ct_fs_24"></i>
                    <i class="fa-solid fa-star ct_yellow_text ct_fs_24"></i>
                    <i class="fa-solid fa-star ct_yellow_text ct_fs_24"></i>
                    <i class="fa-solid fa-star ct_yellow_text ct_fs_24"></i>
                  </div>
                  <p
                    className="mb-0 ct_fs_18 ct_darksky_blue_text"
                    style={{ maxWidth: "323px" }}
                  >
                    Trusted for clarity, strategy, and real support
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class=" ct_py_130">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <h4 class="ct_fs_32 ct_darkblue_text text-center ct_mb_60">
                About {state?.data?.full_name ?? ""}
              </h4>
            </div>
          </div>
          <div class="row align-items-center">
            <div class="col-xxl-7 col-xl-7 col-lg-7 mb-4 mb-lg-0">
              <h4 class="ct_fs_28 mb-4 ct_orange_text">
                Meet {state?.data?.full_name ?? ""}
              </h4>
              <h5 className="ct_fs_22 ct_darksky_blue_text mb-4">
                {state?.data?.role ?? ""}
              </h5>
              <p
                class="ct_fs_20 mb-4 ct_darkblue_text ct_para_scroll ct_custom_scroll"
                style={{ maxWidth: "566px" }}
              >
                {state?.data?.tagline ?? ""}
              </p>
            </div>
            <div class="col-xxl-5 col-xl-5 col-lg-5 mb-4 mb-lg-0">
              <div>
                <img
                  class="ct_img_h_400"
                  src={
                    state?.data?.profile_image ??
                    "../assets/img/coach-profile_right_img.png"
                  }
                  style={{ objectFit: "contain" }}
                />
              </div>
            </div>
          </div>
          <div class="row align-items-center ct_mt_60">
            <div class="col-xxl-5 col-xl-5 col-lg-5 mb-4 mb-lg-0">
              <div>
                <img
                  class="ct_img_h_400"
                  src="../assets/img/approach_coaching_img_12.png"
                />
              </div>
            </div>
            <div class="col-xxl-7 col-xl-7 col-lg-7 mb-4 mb-lg-0 ps-lg-5">
              <h4 class="ct_fs_28 mb-4 ct_orange_text">
                My Approach to Coaching
              </h4>
              <p
                class="ct_fs_20 ct_darkblue_text mb-4 ct_para_scroll ct_custom_scroll"
                style={{ maxWidth: "553px" }}
              >
                Over the last 6 years, I’ve supported business owners,
                creatives, and visionaries in building simple, strategic paths
                to success.
              </p>
              <p
                class="ct_fs_20 ct_darkblue_text mb-4"
                style={{ maxWidth: "540px" }}
              >
                My coaching blends business strategy with mindset work — because
                I believe clarity isn’t just about the next step, it’s about how
                you feel taking it.
              </p>
              <p
                class="ct_fs_20 ct_darkblue_text mb-0"
                style={{ maxWidth: "540px" }}
              >
                Whether you're stuck, starting fresh, or scaling an idea that
                won’t quit, I’m here to help you move forward with purpose.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section class=" ct_px_40 ct_py_130 pt-0">
        <div class="container-fluid">
          <div class="row align-items-center">
            <div
              class="col-lg-3 mb-4 mb-lg-0 aos-init aos-animate"
              data-aos="fade-right"
              data-aos-duration="1500"
            >
              <div class="ct_how_work_img">
                <img src="../assets/img/apply_left_img.png" alt="" />
              </div>
            </div>
            <div
              class="col-lg-9 mb-4 mb-lg-0 ps-lg-5"
              data-aos="fade-left"
              data-aos-duration="1500"
            >
              <div class="ct_how_work_content">
                <h4 class="ct_fs_24 ct_darkblue_text">How I Coach?</h4>
                <h3 class="ct_fs_32 ct_darkblue_text ">
                  Choose the coaching format that fits you
                </h3>
              </div>
              <div class="row mt-5">
                <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                  <div class="ct_how_work_card">
                    <img
                      src="../assets/img/ri_find-replace-fill.png"
                      alt=""
                      className="ct_w_50_340"
                    />
                    <div class="pt-4">
                      <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                        Personal Coaching
                      </h5>
                      <p
                        class="mb-0 ct_fs_16 ct_darkblue_text"
                        style={{ maxWidth: "243px" }}
                      >
                        Work with me one-on-one to gain clarity, build momentum,
                        and launch with support at every step
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                  <div class="ct_how_work_card ">
                    <img
                      src="../assets/img/work_icon_2.png"
                      alt=""
                      className="ct_w_50_340"
                    />
                    <div class="pt-4">
                      <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                        Team Coaching
                      </h5>
                      <p
                        class="mb-0 ct_fs_16 ct_darkblue_text"
                        style={{ maxWidth: "234px" }}
                      >
                        Learn Designed for co-founders or small teams who needs
                        alignment, strategy and a shared roadmap for growth.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                  <div class="ct_how_work_card ">
                    <img
                      src="../assets/img/uim_bag.png"
                      alt=""
                      className="ct_w_50_340"
                    />
                    <div class="pt-4">
                      <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                        Group Coaching
                      </h5>
                      <p
                        class="mb-0 ct_fs_16 ct_darkblue_text"
                        style={{ maxWidth: "232px" }}
                      >
                        Join a small cohort to connect, learn, and improve
                        together in a supportive environment- ideal for
                        peer-driven growth and accountability.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="ct_px_40  pt-0">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="ct_video_section">
                <div className="ct_video_section_img">
                  <img src="../assets/img/video_section_bg.png" />
                </div>
                <div className="ct_video_overlay_content text-center">
                  <div className="ct_play_icon mb-3">
                    <i class="fa-solid fa-play"></i>
                  </div>
                  <h4 className="ct_fs_32 text-white mb-3 ">
                    Meet {state?.data?.full_name ?? ""} in 60 Seconds
                  </h4>
                  <p
                    className="mb-0 mx-auto text-white"
                    style={{ maxWidth: "600px" }}
                  >
                    Get a quick look at her coaching style, who she helps, and
                    how she guides founders from idea to launch.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        data-aos="fade-left"
        data-aos-duration="1500"
        class="ct_looking_for_work_bg     ct_p_111_y_106 ct_mt_100"
        style={{ backgroundColor: "#8ECAE6" }}
      >
        <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
          <div class="text-white">
            <h4 class="ct_fs_36 mb-4">Ready to Take the Next Step?</h4>
            <p class="mb-0 ct_fs_18 ct_fw_300" style={{ maxWidth: "619px" }}>
              Whether you’re launching something new or levelling up your
              strategy, let’s make it happen together.
            </p>
          </div>
          <div class="ct_flex_shrink_0">
            <a
              class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
            // onClick={() => navigate(coachPaths?.ContactUs)}
            >
              View {state?.data?.full_name ?? ""} Package
            </a>
          </div>
        </div>
      </section>

      <section
        className="ct_coach_created_bg ct_px_40 ct_py_130"
        style={{ backgroundColor: "hsl(199deg 64% 73% / 30%)" }}
      >
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12 text-center">
              <h2 className="ct_fs_32 ct_darkblue_text">
                {state?.data?.full_name ?? ""} Workshop
              </h2>
              <p
                className="ct_fs_20 mx-auto ct_darkblue_text"
                style={{ maxWidth: "1000px" }}
              >
                Learn with me in a live, hands on environment designed to spark
                clarity and momentum no long-term commitment needed
              </p>
            </div>
            <div className="col-md-12 mt-5">
              <WorkshopSlider getAllCoachWorkshop={getAllCoachWorkshop} />
            </div>
          </div>
        </div>
      </section>

      <section
        class=" ct_story_light_bg ct_px_40 ct_py_130 ct_mt_100 ct_mb_100"
        style={{ backgroundColor: "#F5F3EF" }}
      >
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-4 mb-4 mb-lg-0">
              <div class="d-grid h-100 pt-2 pb-5">
                <h2
                  class="ct_fs_40 ct_darkblue_text"
                  style={{ maxWidth: "300px" }}
                >
                  Real Stories, real <span class="ct_yellow_text">success</span>
                </h2>
                <div className="ct_arrows mt-auto">
                  <button className="ct_prev ct_arrow_btn" ref={prevRef}>
                    <i class="fa-solid fa-arrow-left"></i>
                  </button>
                  <button className="ct_next ct_arrow_btn" ref={nextRef}>
                    <i class="fa-solid fa-arrow-right"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="col-lg-8 mb-4 mb-lg-0">
              <Swiper
                modules={[Navigation, Autoplay]}
                spaceBetween={20}
                slidesPerView={1}
                loop={true}
                autoplay={{ delay: 2500 }}
                navigation={{
                  prevEl: prevRef.current,
                  nextEl: nextRef.current,
                }}
                onBeforeInit={(swiper) => {
                  swiper.params.navigation.prevEl = prevRef.current;
                  swiper.params.navigation.nextEl = nextRef.current;
                }}
                className="ct_real_stories_slider"
              >
                {/* Slide 1 */}
                <SwiperSlide>
                  <div className="ct_story_slide_card">
                    <div className="ct_story_user_img">
                      <img src="../assets/img/real_succss_img_457.png" alt="" />
                    </div>
                    <div>
                      <div className="ct_orange_text mb-3">
                        <i className="fa-solid fa-star"></i>
                        <i className="fa-solid fa-star"></i>
                        <i className="fa-solid fa-star"></i>
                        <i className="fa-solid fa-star"></i>
                        <i className="fa-solid fa-star"></i>
                      </div>
                      <h3 className="ct_fs_20 ct_darkblue_text mb-3">
                        Climbing Higher with Every Project
                      </h3>
                      <p
                        className="ct_fS_18 ct_darkblue_text"
                        style={{ maxWidth: "402px" }}
                      >
                        NuStar gave me access to exclusive projects that truly
                        challenged and grew my expertise...
                      </p>
                      <div className="mt-5">
                        <h4 className="ct_fs_20 ct_darkblue_text">
                          Chloe Adams
                        </h4>
                        <p className="ct_fs_18 ct_darkblue_text">
                          Product Director at Zenith Tech
                        </p>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="ct_story_slide_card">
                    <div className="ct_story_user_img">
                      <img
                        src="../assets/img/pexels-fauxels-31828341212.png"
                        alt=""
                      />
                    </div>
                    <div>
                      <div className="ct_orange_text mb-3">
                        <i className="fa-solid fa-star"></i>
                        <i className="fa-solid fa-star"></i>
                        <i className="fa-solid fa-star"></i>
                        <i className="fa-solid fa-star"></i>
                        <i className="fa-solid fa-star"></i>
                      </div>

                      <h3 className="ct_fs_20 ct_darkblue_text mb-3">
                        Built for the Big Stage
                      </h3>

                      <p
                        className="ct_fS_18 ct_darkblue_text"
                        style={{ maxWidth: "402px" }}
                      >
                        Working through NuStar pushed me to deliver my best. The
                        opportunities I seized here propelled me into leading
                        high-profile product launches globally.
                      </p>

                      <div className="mt-5">
                        <h4 className="ct_fs_20 ct_darkblue_text">
                          Oliver Hayes
                        </h4>
                        <p className="ct_fs_18 ct_darkblue_text">
                          Head of Product Innovation at SkyLabs
                        </p>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
        </div>
      </section>

      <section class="ct_looking_for_work_bg ct_looking_for_work_bg_left  ct_pt_140_pb_77">
        <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
          <div class="text-white">
            <h4 class="ct_fs_36 mb-3" style={{ maxWidth: "700px" }}>
              Want to Go Deeper? Join My Next Live Workshop
            </h4>
            <p class="mb-0 ct_fs_18" style={{ maxWidth: "623px" }}>
              Exploee real-time coaching with practical exercises, live Q&A ,
              and powerful breakthroughs alongside other founders
            </p>
          </div>
          <div class="ct_flex_shrink_0">
            <a class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5">
              View Workshop
            </a>
          </div>
        </div>
      </section>
      {coachEbook?.length != 0 && (
        <section class="ct_coach_created_bg ct_px_40 ">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12 text-center">
                <h2 class="ct_fs_32 ct_darkblue_text">
                  Coach-Created eBooks, Real-World Wisdom
                </h2>
                <p
                  className="ct_fs_20 mx-auto ct_darkblue_text"
                  style={{ maxWidth: "1000px" }}
                >
                  Get actionable insights, strategies, and tools straight from
                  the coaches who guide founders, leaders, and teams every day.
                </p>
              </div>
              <EBookSlider getAllEBookList={coachEbook} />
            </div>
          </div>
        </section>
      )}
      <section class=" ct_px_40 pt-0 ct_mt_100">
        <div class="container-fluid">
          <div class="row align-items-center">
            <div
              class="col-xxl-7 col-xl-7 col-md-6 mb-4 mb-md-0 "
              data-aos="fade-right"
              data-aos-duration="1500"
            >
              <div class="ct_about_cnt">
                <h2 class=" ct_fs_32  ct_mb_60">Frequently asked questions</h2>

                <div class="ct_faq_question_main">
                  <div class="accordion" id="faq_accordionExample">
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="faq_one">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapsefaq_one"
                          aria-expanded="false"
                          aria-controls="collapsefaq_one"
                        >
                          How do I find a coach on NUVIO?
                        </button>
                      </h2>
                      <div
                        id="collapsefaq_one"
                        class="accordion-collapse collapse"
                        aria-labelledby="faq_one"
                        data-bs-parent="#faq_accordionExample"
                      >
                        <div class="accordion-body">
                          <p class="ct_fs_20 mb-3 ct_line_h_30">
                            These costs can spiral but that didn't seem fair. So
                            our prices work differently. Small businesses often
                            need to do similar things: sell online, book
                            appointments, make reservations. So we offer
                            cheaper, pre-packaged Studio Store apps - that solve
                            these brilliantly.
                          </p>
                          <p class="ct_fs_20 mb-0 ct_line_h_30">
                            If you’re doing something new, on a bigger scale, or
                            need more flexibility, then Builder Studio is for
                            you. Prices vary depending on the features you need
                            but again, you’ll know exactly what you’re paying
                            upfront.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="faqtwo">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapsefaq_Two"
                          aria-expanded="true"
                          aria-controls="collapseTwo"
                        >
                          What types of coaching are available?
                        </button>
                      </h2>
                      <div
                        id="collapsefaq_Two"
                        class="accordion-collapse collapse "
                        aria-labelledby="faqtwo"
                        data-bs-parent="#faq_accordionExample"
                      >
                        <div class="accordion-body">
                          <p class="ct_fs_20 mb-3 ct_line_h_30">
                            These costs can spiral but that didn't seem fair. So
                            our prices work differently. Small businesses often
                            need to do similar things: sell online, book
                            appointments, make reservations. So we offer
                            cheaper, pre-packaged Studio Store apps - that solve
                            these brilliantly.
                          </p>
                          <p class="ct_fs_20 mb-0 ct_line_h_30">
                            If you’re doing something new, on a bigger scale, or
                            need more flexibility, then Builder Studio is for
                            you. Prices vary depending on the features you need
                            but again, you’ll know exactly what you’re paying
                            upfront.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="faqthree">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapsefaq_Three"
                          aria-expanded="false"
                          aria-controls="collapsefaq_Three"
                        >
                          How do I book a session with a coach?
                        </button>
                      </h2>
                      <div
                        id="collapsefaq_Three"
                        class="accordion-collapse collapse"
                        aria-labelledby="faqthree"
                        data-bs-parent="#faq_accordionExample"
                      >
                        <div class="accordion-body">
                          <p class="ct_fs_20 mb-3 ct_line_h_30">
                            These costs can spiral but that didn't seem fair. So
                            our prices work differently. Small businesses often
                            need to do similar things: sell online, book
                            appointments, make reservations. So we offer
                            cheaper, pre-packaged Studio Store apps - that solve
                            these brilliantly.
                          </p>
                          <p class="ct_fs_20 mb-0 ct_line_h_30">
                            If you’re doing something new, on a bigger scale, or
                            need more flexibility, then Builder Studio is for
                            you. Prices vary depending on the features you need
                            but again, you’ll know exactly what you’re paying
                            upfront.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="faqFour">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapsefaq_Four"
                          aria-expanded="false"
                          aria-controls="collapsefaq_Four"
                        >
                          How do I know if a coach is the right fit for me?
                        </button>
                      </h2>
                      <div
                        id="collapsefaq_Four"
                        class="accordion-collapse collapse"
                        aria-labelledby="faqFour"
                        data-bs-parent="#faq_accordionExample"
                      >
                        <div class="accordion-body">
                          <p class="ct_fs_20 mb-3 ct_line_h_30">
                            These costs can spiral but that didn't seem fair. So
                            our prices work differently. Small businesses often
                            need to do similar things: sell online, book
                            appointments, make reservations. So we offer
                            cheaper, pre-packaged Studio Store apps - that solve
                            these brilliantly.
                          </p>
                          <p class="ct_fs_20 mb-0 ct_line_h_30">
                            If you’re doing something new, on a bigger scale, or
                            need more flexibility, then Builder Studio is for
                            you. Prices vary depending on the features you need
                            but again, you’ll know exactly what you’re paying
                            upfront.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="faqFive">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapsefaq_Five"
                          aria-expanded="false"
                          aria-controls="collapsefaq_Five"
                        >
                          Can I contact a coach before booking?
                        </button>
                      </h2>
                      <div
                        id="collapsefaq_Five"
                        class="accordion-collapse collapse"
                        aria-labelledby="faqFive"
                        data-bs-parent="#faq_accordionExample"
                      >
                        <div class="accordion-body">
                          <p class="ct_fs_20 mb-3 ct_line_h_30">
                            These costs can spiral but that didn't seem fair. So
                            our prices work differently. Small businesses often
                            need to do similar things: sell online, book
                            appointments, make reservations. So we offer
                            cheaper, pre-packaged Studio Store apps - that solve
                            these brilliantly.
                          </p>
                          <p class="ct_fs_20 mb-0 ct_line_h_30">
                            If you’re doing something new, on a bigger scale, or
                            need more flexibility, then Builder Studio is for
                            you. Prices vary depending on the features you need
                            but again, you’ll know exactly what you’re paying
                            upfront.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="col-xxl-4  col-xl-5 col-md-6 mb-4 mb-md-0 ps-xl-5 "
              data-aos="fade-left"
              data-aos-duration="1500"
            >
              <div class="ct_about_img">
                <img
                  src="../assets/img/pexels-fauxels_456.png"
                  class="ct_img_h_617"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        data-aos="fade-left"
        data-aos-duration="1500"
        class="ct_looking_for_work_bg     ct_p_111_y_106 ct_mt_100"
        style={{ backgroundColor: "var(--orange)" }}
      >
        <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
          <div class="text-white">
            <h4 class="ct_fs_36 mb-4">
              Looking for More Support Beyond Coaching?
            </h4>
            <p class="mb-0 ct_fs_18 ct_fw_300" style={{ maxWidth: "619px" }}>
              From web design and marketing to sales strategy and customer
              experience, Nuvio offers everything you need to grow with clarity.
            </p>
          </div>
          <div class="ct_flex_shrink_0">
            <a
              class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
              onClick={() => navigate(coachPaths?.ContactUs)}
            >
              Explore Services
            </a>
          </div>
        </div>
      </section>

      <section className="ct_px_40 ct_py_130 pb-0">
        <div className="container-fluid">
          {/* convert into slider */}
          <div className="row">
            <div className="col-lg-4 col-md-6 mb-4">
              <div class="ct_testimonial_review_card h-100 d-grid">
                <div>
                  <div className="d-flex align-items-center gap-3 mb-3 justify-content-between">
                    <div class="d-flex align-items-center gap-1">
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                    </div>
                    <p className="mb-0 ct_fs_16">20th April, 2025</p>
                  </div>
                  <p className="mb-0 " style={{ maxWidth: "295px" }}>
                    The expert sessions and networking inside NuForge are next
                    level. I finally feel part of a serious community that
                    pushes me to grow.
                  </p>
                </div>
                <div className="mt-auto">
                  <div class="d-flex align-items-center gap-3 ct_mt_40">
                    <img
                      src="/assets/img/Ellipse 24.png"
                      class="ct_img_60 "
                      alt=""
                    />
                    <div>
                      <h5 class="ct_fs_18  mb-1 me-1 ct_grey_text">
                        Alex Robertson
                      </h5>
                      <p class="mb-0  ct_fs_16  ">Frontend Developer</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div class="ct_testimonial_review_card h-100 d-grid">
                <div>
                  <div className="d-flex align-items-center gap-3 mb-3 justify-content-between">
                    <div class="d-flex align-items-center gap-1">
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                    </div>

                    <p className="mb-0 ct_fs_16">20th April, 2025</p>
                  </div>
                  <p className="mb-0 " style={{ maxWidth: "295px" }}>
                    With NuForge, I refined my services, rebranded my profile,
                    and doubled my client reach in just a few weeks. Totally
                    worth it!
                  </p>
                </div>
                <div className="mt-auto">
                  <div class="d-flex align-items-center gap-3 ct_mt_40">
                    <img
                      src="/assets/img/Ellipse 24 (1).png"
                      class="ct_img_60 "
                      alt=""
                    />
                    <div>
                      <h5 class="ct_fs_18  mb-1 me-1 ct_grey_text">
                        Olivia Brooks
                      </h5>
                      <p class="mb-0  ct_fs_16  ">Mobile App Developer</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div class="ct_testimonial_review_card h-100 d-grid">
                <div>
                  <div className="d-flex align-items-center gap-3 mb-3 justify-content-between">
                    <div class="d-flex align-items-center gap-1">
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                      <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                    </div>

                    <p className="mb-0 ct_fs_16">20th April, 2025</p>
                  </div>
                  <p className="mb-0 " style={{ maxWidth: "295px" }}>
                    NuForge helped me position myself for higher-paying clients
                    by improving my portfolio and strategy.
                  </p>
                </div>
                <div className="mt-auto">
                  <div class="d-flex align-items-center gap-3 ct_mt_40">
                    <img
                      src="/assets/img/Ellipse 24 (2).png"
                      class="ct_img_60 "
                      alt=""
                    />
                    <div>
                      <h5 class="ct_fs_18  mb-1 me-1 ct_grey_text">
                        James Thornton
                      </h5>
                      <p class="mb-0  ct_fs_16  ">Cloud Solutions Architect</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <footer class="ct_px_40 py-5">
        <div class="ct_footer_logo">
          <a>
            <img src="../assets/img/Nuvio_logo.png" alt="" />
          </a>
        </div>
        <div class="row pt-4">
          <div class="col-xxl-3 col-xl-2 col-md-6 mb-4">
            <div class="ct_footer_links">
              <h4 class="ct_fs_20 ct_darkblue_text mb-3">Navigation</h4>
              <ul>
                <li>
                  <a>For Enterprises</a>
                </li>
                <li>
                  <a>For Freelancers</a>
                </li>
                <li>
                  <a>CoachHUB</a>
                </li>
                <li>
                  <a>Funding</a>
                </li>
                <li>
                  <a>About us</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-xxl-3 col-xl-2 col-md-6 mb-4">
            <div class="ct_footer_links">
              <h4 class="ct_fs_20 ct_darkblue_text mb-3">Resources</h4>
              <ul>
                <li>
                  <a>Blog</a>
                </li>
                <li>
                  <a>Newsletter</a>
                </li>
                <li>
                  <a>Tutorials</a>
                </li>
                <li>
                  <a>Support</a>
                </li>
                <li>
                  <a>Help Centre</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-xxl-2 col-xl-3 col-md-6 mb-4">
            <div class="ct_footer_links">
              <h4 class="ct_fs_20 ct_darkblue_text mb-3">Get in Touch</h4>
              <ul>
                <li>
                  <a href="mailto:hello@nu-vio.com">
                    <i class="fa-solid fa-envelope me-1 ct_yellow_text"></i>
                    hello@nu-vio.com
                  </a>
                </li>
                <li>
                  <a href="tel:+123-456-789">
                    <i class="fa-solid fa-phone me-1 ct_yellow_text"></i>
                    +123-456-789
                  </a>
                </li>
                <li>
                  <a>
                    <i class="fa-solid fa-location-dot ct_yellow_text me-1"></i>{" "}
                   Office 36, 1 Exchange Building (TBE), Cybercity, Ebene Mauritius
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-xxl-4 col-xl-5 col-md-6 mb-4">
            <div class="ct_newsletter_bg">
              <p>Ready to keep up with what’s next?</p>
              <div class="d-flex align-items-center gap-2 justify-content-between ct_flex_col_991">
                <div class="form-group ct_flex_1 ct_w_100_991">
                  <input
                    type="email"
                    class="form-control ct_input ct_border_radius_100"
                    placeholder="Enter your email address"
                  />
                </div>
                <div class="ct_w_100_991">
                  <button class="ct_yellow_btn ct_darkblue_btn ct_border_radius_100 ct_h_48 ct_w_100_991">
                    Subscribe now
                  </button>
                </div>
              </div>
            </div>
            <div class="pt-4">
              <h5 class="ct_fs_18 mb-3">Follow Us</h5>
              <div class="d-flex align-items-center gap-2">
                <a style={{ color: "#0076B2" }}>
                  <i class="fa-brands fa-linkedin"></i>
                </a>
                <a style={{ color: "#3D5A98" }}>
                  <i class="fa-brands fa-square-facebook"></i>
                </a>
                <a style={{ color: "#FF0000" }}>
                  <i class="fa-brands fa-youtube"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="row pt-4 ct_border_top_1">
          <div class="col-md-12">
            <p class="mb-0 text-center">
              Copyright @ 2025 NUVIO All Rights Reserved
            </p>
          </div>
        </div>
      </footer> */}

      <div
        class="modal fade ct_submit_modal"
        id="ct_submit_modal"
        tabindex="-1"
        aria-labelledby="ct_submit_modalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body py-5">
              <div class="mx-auto d-block text-center mb-4">
                <svg
                  width="80"
                  height="80"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24 48C17.6348 48 11.5303 45.4714 7.02944 40.9706C2.52856 36.4697 0 30.3652 0 24C0 17.6348 2.52856 11.5303 7.02944 7.02944C11.5303 2.52856 17.6348 0 24 0C30.3652 0 36.4697 2.52856 40.9706 7.02944C45.4714 11.5303 48 17.6348 48 24C48 30.3652 45.4714 36.4697 40.9706 40.9706C36.4697 45.4714 30.3652 48 24 48ZM19.2 36L40.8 15.6L37.2 12L19.2 28.8L10.8 20.4L7.2 24L19.2 36Z"
                    fill="#FFB703"
                  />
                </svg>
              </div>
              <div class="text-center">
                <h4 class="ct_fs_20 ">Application Submitted</h4>
                <p>
                  Thanks for applying to become a coach on Nuvio CoachHUB. Our
                  team is currently reviewing your application
                </p>
              </div>
              <div class="text-center mt-4 d-flex align-items-center gap-3 justify-content-center ct_flex_col_575 ct_w_100_575">
                <a class="ct_yellow_btn ct_outline_grey ct_h_48 px-5 ct_w_100_575">
                  View Coaches
                </a>
                <button
                  class="ct_yellow_btn ct_h_48  px-5 ct_w_100_575"
                  data-bs-dismiss="modal"
                >
                  Close{" "}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal fade modal-lg"
        id="ct_schedule_interview12"
        tabindex="-1"
        aria-labelledby="ct_schedule_interview12Label"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content ">
            <div class="modal-header border-0 pb-0">
              <button
                type="button"
                class="btn-close ct_circle_close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <h4 class=" mb-1 ct_fs_20 ct_yellow_text">
                Select a Coaching Session
              </h4>
              <p class="mb-0  ct_grey_text ">
                Choose the session that fits your goals with Nellie Padille
              </p>
              <hr style={{ borderColor: "rgb(205 192 192)" }} />
              <ul>
                <li>
                  <div class="ct_radio-wrapper align-items-start">
                    <div class="ct_radio-container ct_radio_container_yellow mt-1">
                      <div class="ct_radio-wrapper">
                        <label class="ct_radio-button">
                          <input
                            id="option1"
                            name="ct_radio-group"
                            type="radio"
                          />
                          <span
                            class="ct_radio-checkmark"
                            style={{ borderColor: "#02304726" }}
                          ></span>
                        </label>
                      </div>
                    </div>
                    <div>
                      <p class="mb-1 ct_darkblue_text">Discovery Call – Free</p>
                      <p className="mb-0 ct_grey_text">
                        30-minute sessions designed to explore shared challenges
                        and collective goals.
                      </p>
                    </div>
                  </div>
                </li>
                <li className="ct_mt_20">
                  <div class="ct_radio-wrapper align-items-start">
                    <div class="ct_radio-container ct_radio_container_yellow mt-1">
                      <div class="ct_radio-wrapper">
                        <label class="ct_radio-button">
                          <input
                            id="option1"
                            name="ct_radio-group"
                            type="radio"
                          />
                          <span
                            class="ct_radio-checkmark"
                            style={{ borderColor: "#02304726" }}
                          ></span>
                        </label>
                      </div>
                    </div>
                    <div>
                      <p class="mb-1 ct_darkblue_text">
                        Clarity Boost – {curSym} 175
                      </p>
                      <p className="mb-0 ct_grey_text">
                        A focused 60-minute session for quick wins,
                        decision-making, or clarity on a challenge.
                      </p>
                    </div>
                  </div>
                </li>
                <li className="ct_mt_20">
                  <div class="ct_radio-wrapper align-items-start">
                    <div class="ct_radio-container ct_radio_container_yellow mt-1">
                      <div class="ct_radio-wrapper">
                        <label class="ct_radio-button">
                          <input
                            id="option1"
                            name="ct_radio-group"
                            type="radio"
                          />
                          <span
                            class="ct_radio-checkmark"
                            style={{ borderColor: "#02304726" }}
                          ></span>
                        </label>
                      </div>
                    </div>
                    <div>
                      <p class="mb-1 ct_darkblue_text">
                        Growth Pro – {curSym} 199
                      </p>
                      <p className="mb-0 ct_grey_text">
                        Three 60-minute sessions designed for momentum,
                        feedback, and accountability.
                      </p>
                    </div>
                  </div>
                </li>
                <li className="ct_mt_20">
                  <div class="ct_radio-wrapper align-items-start">
                    <div class="ct_radio-container ct_radio_container_yellow mt-1">
                      <div class="ct_radio-wrapper">
                        <label class="ct_radio-button">
                          <input
                            id="option1"
                            name="ct_radio-group"
                            type="radio"
                          />
                          <span
                            class="ct_radio-checkmark"
                            style={{ borderColor: "#02304726" }}
                          ></span>
                        </label>
                      </div>
                    </div>
                    <div>
                      <p class="mb-1 ct_darkblue_text">
                        Deep Dive Coaching – {curSym} 250
                      </p>
                      <p className="mb-0 ct_grey_text">
                        A full 5-session coaching journey with follow-ups,
                        tools, and a personalized plan.
                      </p>
                    </div>
                  </div>
                </li>
              </ul>
              <div className="ct_mt_20">
                <div class="form-check ct_custom_check2 ct_custom_check2_yellow d-flex align-items-center gap-2">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="flexCheckDefault"
                  />
                  <label for="">Send me the recording after the session</label>
                </div>
              </div>
              <div className="ct_mt_20">
                <button
                  className="ct_yellow_btn ct_h_48 w-100"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  Continue to Schedule
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal fade modal-lg"
        id="ct_schedule_interview"
        tabindex="-1"
        aria-labelledby="ct_schedule_interviewLabel"
        aria-hidden="true"
      >
        <div
          class="modal-dialog modal-dialog-centered mx-auto"
          style={{ maxWidth: "1020px" }}
        >
          <div class="modal-content ">
            <div class="modal-header border-0 pb-0">
              <button
                type="button"
                class="btn-close ct_circle_close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body pe-0">
              <h4 className="ct_fs_24_new ct_darkblue_text mb-3">
                Schedule Introductory Meeting
              </h4>
              <div className="row">
                <div className="col-lg-6 mb-4 mb-lg-0">
                  <div
                    className="ct_calender_img_12"
                    style={{ paddingRight: "40px" }}
                  >
                    <img
                      src="../assets/img/Calendar.png"
                      className="img-fluid w-100"
                    />
                  </div>
                </div>
                <div className="col-lg-6 mb-4 mb-lg-0">
                  <div
                    className="ct_calander_scroll123 ct_custom_scroll"
                    style={{ paddingRight: "40px" }}
                  >
                    <div className="ct_clander_head_btm_brder">
                      <p className="mb-1 ct_fs_22 ct_darkblue_text text-end">
                        May 25, 2025
                      </p>
                      <p className="ct_fs_14 text-end mb-0">
                        <span className="ct_fs_16" style={{ color: "#535862" }}>
                          Africa/Lagos
                        </span>
                      </p>
                    </div>
                    <ul className="ct_meeting_tabs_12 ct_mb_30 pt-3">
                      <li>
                        <button className="active">Personal</button>
                      </li>
                      <li>
                        <button>Team</button>
                      </li>
                      <li>
                        <button>Group</button>
                      </li>
                    </ul>
                    <div>
                      <div className="form-group mb-4">
                        <label className="mb-2 ct_fs_14">Name</label>
                        <input
                          type="text"
                          className="form-control ct_input"
                          placeholder="Enter name"
                          required
                        />
                      </div>
                      <div className="form-group mb-4">
                        <label className="mb-2 ct_fs_14">Email</label>
                        <input
                          type="text"
                          className="form-control ct_input"
                          placeholder="Enter email"
                          required
                        />
                      </div>
                      <div className="form-group mb-4">
                        <label className="mb-2 ct_fs_14">Notes(Optional)</label>
                        <textarea
                          type="text"
                          className="form-control ct_input h-auto"
                          rows={4}
                          placeholder="Let the coach know what you will like to focus on....."
                          required
                        />
                      </div>
                      <div className="ct_mt_20 d-flex align-items-center gap-3 justify-content-end">
                        <button
                          type="button"
                          className="ct_yellow_btn ct_outline_grey ct_outline_dark_blue ct_h_48 px-4"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        >
                          Cancel
                        </button>
                        <button
                          className="ct_yellow_btn ct_h_48 px-4 "
                          data-bs-target="#ct_shoose_time_modal"
                          data-bs-toggle="modal"
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal fade modal-lg "
        id="ct_shoose_time_modal"
        tabindex="-1"
        aria-labelledby="ct_shoose_time_modalLabel"
        aria-hidden="true"
      >
        <div
          class="modal-dialog modal-dialog-centered mx-auto"
          style={{ maxWidth: "450px" }}
        >
          <div class="modal-content  border-0" style={{ borderRadius: "20px" }}>
            <div class="modal-header border-0 pb-0">
              <button
                type="button"
                class="btn-close ct_circle_close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body px-5 pb-4">
              <h4 className="ct_fs_18 ct_darkblue_text mb-2 text-center">
                Choose Time
              </h4>
              <p className="mb-0 ct_grey_text  text-center">
                25 May! 60 Minute Meeting{" "}
              </p>
              <hr />
              <div class="time-slot-wrapper mt-4 pt-2">
                <div class="time-slot">11:00 - 12:00</div>
                <div class="time-slot">01:00 - 02:00</div>
                <div class="time-slot active">03:00 - 04:00</div>
                <div class="time-slot">05:00 - 06:00</div>
                <div class="time-slot">06:00 - 07:00</div>
              </div>
              <div className="ct_mt_20">
                <button
                  className="ct_yellow_btn w-100 ct_h_44"
                  data-bs-target="#ct_discover_call"
                  data-bs-toggle="modal"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* discover call S */}
      <div
        className="modal fade ct_reactivate_account "
        id="ct_discover_call"
        tabindex="-1"
        aria-labelledby="ct_discover_callLabel"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered mx-auto"
          style={{ maxWidth: "600px" }}
        >
          <div className="modal-content" style={{ backgroundColor: "#023047" }}>
            <div className="modal-body py-5">
              <section class="dc-wrapper d-flex align-items-center">
                <div class="container">
                  <div class=" mx-auto">
                    <div class="mb-3">
                      <a href="#" class="dc-back">
                        <i class="fa-solid fa-arrow-left"></i>
                      </a>
                    </div>

                    <div className="dc-card">
                      <p class="ct_fs_24_new text-white">
                        👉 Book now, no payment required.
                      </p>

                      <div class="d-flex align-items-center gap-3 mb-3">
                        <h2 class="ct_fs_36 ct_darksky_blue_text ct_fw_700 mb-0">
                          Discovery call
                        </h2>
                        <span class="dc-time-badge px-4">11:00 - 12:00</span>
                      </div>

                      <p
                        class="text-white ct_fs_18"
                        style={{
                          borderBottom: "1px solid #fff",
                          paddingBottom: "5px",
                        }}
                      >
                        Get focused guidance to pinpoint your next step with
                        confidence.
                      </p>

                      <ul class="dc-details list-unstyled">
                        <li className="text-white ct_fs_18">
                          <strong className="ct_yellow_text">Duration:</strong>{" "}
                          30 minutes (Introductory call)
                        </li>
                        <li className="text-white ct_fs_18">
                          <strong className="ct_yellow_text">Format:</strong>{" "}
                          1-1 Live
                        </li>
                        <li className="text-white ct_fs_18">
                          <strong className="ct_yellow_text">Price:</strong>{" "}
                          <span>Free</span>
                        </li>
                      </ul>

                      <div class="dc-box mt-4">
                        <h6 class="dc-box-title ct_fs_18 ct_fw_600">
                          What You'll Get:
                        </h6>
                        <ul class="mb-0 ps-4" style={{ listStyle: "disc" }}>
                          <li className="text-white ct_fs_18">
                            A safe space to share your objectives
                          </li>
                          <li className="text-white ct_fs_18 mt-2">
                            An overview of how coaching can support you
                          </li>
                          <li className="text-white ct_fs_18 mt-2">
                            Clarity on the best path forward
                          </li>
                        </ul>
                      </div>

                      <div class="d-flex justify-content-between align-items-center dc-total mt-4">
                        <span className="ct_fs_20 text-white">Total</span>
                        <span className="ct_fs_20 text-white">$ 0</span>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <div className="text-center mt-4 d-flex align-items-center gap-3 justify-content-center ct_flex_col_575 ct_w_100_575">
                <button
                  className="ct_yellow_btn ct_outline_white_btn ct_h_48  px-5 ct_w_100_575"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  className="ct_yellow_btn ct_h_48 px-5 ct_w_100_575"
                  data-bs-target="#ct_reactivate_account"
                  data-bs-toggle="modal"
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*  discover call E */}
      {/* success account S */}
      <div
        className="modal fade ct_reactivate_account"
        id="ct_reactivate_account"
        tabindex="-1"
        aria-labelledby="ct_reactivate_accountLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body py-5">
              <div className="mx-auto d-block text-center mb-4">
                <svg
                  width="80"
                  height="80"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24 48C17.6348 48 11.5303 45.4714 7.02944 40.9706C2.52856 36.4697 0 30.3652 0 24C0 17.6348 2.52856 11.5303 7.02944 7.02944C11.5303 2.52856 17.6348 0 24 0C30.3652 0 36.4697 2.52856 40.9706 7.02944C45.4714 11.5303 48 17.6348 48 24C48 30.3652 45.4714 36.4697 40.9706 40.9706C36.4697 45.4714 30.3652 48 24 48ZM19.2 36L40.8 15.6L37.2 12L19.2 28.8L10.8 20.4L7.2 24L19.2 36Z"
                    fill="#FFB703"
                  />
                </svg>
              </div>
              <div className="text-center">
                <h4 className="ct_fs_20">Your Discovery Call is confirmed</h4>
                <p className="mb-0 mx-auto" style={{ maxWidth: "348px" }}>
                  We’ve sent all the details to your email, including the
                  meeting link and your workbook.
                </p>
              </div>
              <div className="text-center mt-4 d-flex align-items-center gap-3 justify-content-center ct_flex_col_575 ct_w_100_575">
                <button
                  className="ct_yellow_btn ct_outline_grey ct_h_48  px-5 ct_w_100_575"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  data-bs-target="#ct_schedule_interview"
                  data-bs-toggle="modal"
                >
                  Reschedule
                </button>
                <button className="ct_yellow_btn ct_h_48 px-5 ct_w_100_575"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* success account E */}

      <div style={{ height: "100px" }}></div>
    </MenuLayout>
  );
};
